<button
	id="{{ name }}BtnDropDown"
	class="btn-drop-down"
	type="button"
	[disabled]="isDisabled"
	[attr.aria-label]="ariaLabel"
	[attr.role]="buttonRole"
	(click)="handleClick()"
>
	<ng-content></ng-content>
	@if (caretUp) {
		<i class="fa fa-caret-up" aria-hidden="true"></i>
	}
	@if (!caretUp) {
		<i class="fa fa-caret-down" aria-hidden="true"></i>
	}
</button>
@if (!caretUp) {
	<div class="btn-drop-down-content">
		<ul class="btn-drop-down-list">
			@for (item of dropDownItems; track item) {
				<li>
					@if (item.show) {
						<a
							routerLinkActive="active"
							class="{{ item.display }}-drop-down">
							<ea-button-link
								class="btn-drop-down-items"
								tabindex="-1"
								[name]="item.display"
								[routerLink]="item.href"
								[title]="item.display"
								(click)="handleClick()">
								{{ item.display }}
							</ea-button-link>
						</a>
					}
				</li>
			}
		</ul>
	</div>
}
@if (!caretUp) {
	<ea-ui-overlay (close)="handleClick()"></ea-ui-overlay>
}
